module.exports = __webpack_public_path__ + "assets/SumSquaresDetailed.8a22e766f7b41531ada9388eae6149e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/SumSquaresDetailed.png
// module id = 571
// module chunks = 0